module.exports = __webpack_public_path__ + "static/media/logo_s2p.dc14eff2.png";